// internal
import { ZoneType } from '@app/store/typings/actions/zone.d';
import { ZoneState } from '@app/store/typings/state/zone.d';

const initState: ZoneState = {
  lists: [],
  data: [],
  loading: false,
  modalCreate: false,
};

export const zone = (state = initState, action: ZoneType) => {
  switch (action.type) {
    case 'KEY_ZONE_SELECT_SET_DATA':
      state.lists = action.payload;
      return { ...state };
    case 'KEY_ZONE_FETCH':
      state.loading = false;
      return { ...state };
    case 'KEY_ZONE_SET_DATA':
      state.data = action.payload.data;
      state.loading = false;
      return { ...state };
    case 'KEY_ZONE_MODAL_CREATE':
      state.modalCreate = !state.modalCreate;
      if (action.payload !== undefined) {
        state.modalCreate = action.payload;
      }

      return { ...state };
    default:
      return state;
  }
};
